let elements = {
  //pick: 3,
  blockCheck: true,
  permanent: true,
  mainImage: {
    imagePath: 'games/page045_game0/img/bcg2.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page045_game0/audio/false.mp3',
    // positive: 'games/page045_game0/audio/7_mole.mp3',
    click: 'games/page045_game0/audio/click.mp3',
    icon: {
      on: 'games/page045_game0/img/audioOn.png',
      off: 'games/page045_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 251,
    height: 265,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 873,
        y: 295,
      },
    },
    {
      pos: {
        x: 1364,
        y: 295,
      },
    },
    {
      pos: {
        x: 1118,
        y: 295,
      },
    },

    {
      pos: {
        x: 1609,
        y: 295,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: false,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page045_game0/audio/58_hands.mp3',
          correct: {
            image: {
              src: 'games/page045_game0/img/br_hands.webp',
            },
            width: 251,
            height: 265,
            correctItems: {
              images: [
                {
                  src: 'games/page045_game0/img/br_hands_ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 251,
                  height: 265,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page045_game0/img/br_head.webp',
            },
            width: 251,
            height: 265,
            incorrectItems: {
              images: [
                {
                  src: 'games/page045_game0/img/br_head_wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 251,
                  height: 265,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page045_game0/audio/57_legs.mp3',
          correct: {
            image: {
              src: 'games/page045_game0/img/br_legs.webp',
            },
            width: 251,
            height: 265,
            correctItems: {
              images: [
                {
                  src: 'games/page045_game0/img/br_legs_ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 251,
                  height: 265,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page045_game0/audio/60_tummy.mp3',
          correct: {
            image: {
              src: 'games/page045_game0/img/br_stomach.webp',
            },
            width: 251,
            height: 265,
            correctItems: {
              images: [
                {
                  src: 'games/page045_game0/img/br_stomach_ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 251,
                  height: 265,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],

  mbStaticAudioItemData: [
    {
      src: 'games/page045_game0/audio/58_hands.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page045_game0/img/audioOn.png', iconOff: 'games/page045_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 975,
        y: 254,
      },
      unit: 'px',
    },
    {
      src: 'games/page045_game0/audio/57_legs.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page045_game0/img/audioOn.png', iconOff: 'games/page045_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 1225,
        y: 254,
      },
      unit: 'px',
    },
    {
      src: 'games/page045_game0/audio/59_head.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page045_game0/img/audioOn.png', iconOff: 'games/page045_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 1465,
        y: 254,
      },
      unit: 'px',
    },
    {
      src: 'games/page045_game0/audio/60_tummy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page045_game0/img/audioOn.png', iconOff: 'games/page045_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 1710,
        y: 254,
      },
      unit: 'px',
    },
  ],
};

export default elements;
